import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'quoteandbind.pa.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.pa.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.pa.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.pa.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    }
});
